import { ChevronDown, ChevronRight } from "react-feather";

/** Expand/collapse indicator — avoids Font Awesome webfont (missing .woff2 in repo). */
const SidebarChevron = ({ open, className = "according-menu" }) => {
  const Icon = open ? ChevronDown : ChevronRight;
  return (
    <div className={className}>
      <Icon size={16} strokeWidth={2} aria-hidden />
    </div>
  );
};

export default SidebarChevron;
